import React from 'react'
import css from './style.scss'
import cn from 'classnames'
import {n} from 'shared/numbers'

export const NumberBox=(props)=>(
  <div className={cn(css.numberBox, props.className)}>
    <div className={css.numberBox_title}>{props.title}</div>
    <div className={css.numberBox_numbers}>
      <div className={css.numberBox_value}>{props.children}</div>
      {props.percentage!==undefined && props.percentage >0 && <div className={css.numberBox_percentage}>{n(props.percentage)}<small>%</small></div>}
    </div>
  </div>
)

export const StatTitle=(props)=>(
  <div className={css.statTitle}>{props.children}</div>
)

export const Row=(props)=>(
  <div className={css.row}>{props.children}</div>
)



// WEBPACK FOOTER //
// ./src/components/account_page/stats/sections/utils.js